import camelCase from 'lodash/camelCase'

import { SAT_COMPLIANCE_STATUS_COLOR_MAP } from 'constants/colorMaps'

export const CLIENT_COMPLIANCE_STATUSES = [
  'compliant',
  'soon_out_of_compliance',
  'out_of_compliance',
  'not_used',
]

export const complianceLabel = (t, status) => {
  return t(`satCompliance.${camelCase(status)}`)
}

export const complianceOptions = (t) => {
  return CLIENT_COMPLIANCE_STATUSES.map(status => {
    return { value: status, label: complianceLabel(t, status) }
  })
}

export const complianceColorsByLabel = (t) => {
  return Object.fromEntries(
    Object.entries(SAT_COMPLIANCE_STATUS_COLOR_MAP)
      .map(([status, color]) => [complianceLabel(t, status), color])
  )
}
